import { useGetAllPlans } from '@/api/generated/flow/flow';
import type { FinancialPlan } from '@/api/generated/model';
import type { QueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

/** Accepts a bare array or paginated `{ items }` payload from GET /api/plans. */
export function asPlanList(data: unknown): FinancialPlan[] {
  if (Array.isArray(data)) return data;
  if (data && typeof data === 'object' && Array.isArray((data as { items?: unknown }).items)) {
    return (data as { items: FinancialPlan[] }).items;
  }
  return [];
}

type UseGetAllPlansOptions = NonNullable<Parameters<typeof useGetAllPlans>[0]>;

export function usePlansList(options?: UseGetAllPlansOptions, queryClient?: QueryClient) {
  const query = useGetAllPlans(options, queryClient);
  const plans = useMemo(() => asPlanList(query.data), [query.data]);
  return { ...query, plans };
}
